var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper"},[_c('div',{staticClass:"swiper-wrapper"},[_vm._l((_vm.data),function(item,i){return [_c('div',{key:i,staticClass:"swiper-slide"},[_vm._t("default",null,{"slide":item,"index":i})],2)]})],2),_c('div',{staticClass:"swiper-button-prev"}),_c('div',{staticClass:"swiper-button-next"})])
}
var staticRenderFns = []

export { render, staticRenderFns }